import React from "react";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { KycStep } from "../components/KycStep";
import { DocumentCamera } from "../document-camera/DocumentCamera";

// KYC 流程与相机模块之间的薄适配层；媒体结果通过 onCapture 原样交回 KycFlow。
export function DocumentCaptureStep({
  side,
  documentType,
  autoStart,
  onBack,
  onCapture,
}) {
  const { t } = useTranslation();

  return (
    <KycStep
      labelledBy="kyc-document-capture-title"
      className="document-capture-step"
    >
      <DocumentCamera
        side={side}
        documentType={documentType}
        autoStart={autoStart}
        onCapture={onCapture}
      />
      <button
        type="button"
        onClick={onBack}
        className="document-capture-back mx-auto mt-1.5 flex min-h-9 items-center justify-center gap-1.5 rounded-full px-4 text-sm font-semibold text-slate-500 transition hover:bg-slate-50 hover:text-slate-900"
      >
        <ArrowLeft className="size-4" aria-hidden="true" />
        {t("common.back")}
      </button>
    </KycStep>
  );
}
